import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Colors extends Component {
  render() {
    return (
      <EntityList apiRoute='api/colors' title='Remorque - Couleurs' editTitle='Couleur' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Colors;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/colors.js
 **/